import { ExtraPackageDoveIt } from '../../../domain/types';
import { Agent } from '../../../providers/api/dtos';
import {
  DIGITAL_COMPANY_PRESENTATION, MarketingResource, PAPER_COMPANY_PRESENTATION, PREMIUM_MARKETING_RESOURCES, SHOWCASE_LANDSCAPE_RESOURCE, SHOWCASE_PORTRAIT_RESOURCE,
  STANDARD_MARKETING_RESOURCES,
} from './constants';

export const getPresentationResources = (agent: Agent | undefined): MarketingResource[] => {
  const hasCustomPresentation = agent
    && (agent.agencies?.length ?? 0) > 0
    && agent.configuration?.marketing?.customPresentation;

  const agencyId = agent?.agencies?.at(0)?.id?.toString();

  return [
    {
      ...DIGITAL_COMPANY_PRESENTATION,
      fileName: `${hasCustomPresentation ? `${agencyId}/` : ''}${DIGITAL_COMPANY_PRESENTATION.fileName}`,
    },
    {
      ...PAPER_COMPANY_PRESENTATION,
      fileName: `${hasCustomPresentation ? `${agencyId}/` : ''}${PAPER_COMPANY_PRESENTATION.fileName}`,
    },
  ];
};

export const getShowcaseResources = (agent: Agent | undefined, canAccessShowcase: boolean): MarketingResource[] => {
  const hasShowcaseResource = (agent
    && (agent.agencies?.length ?? 0) > 0)
    || canAccessShowcase;

  return hasShowcaseResource ? [SHOWCASE_LANDSCAPE_RESOURCE, SHOWCASE_PORTRAIT_RESOURCE] : [];
};

export function getActualMarketingResources(agent: Agent | undefined, canAccessShowcase: boolean): MarketingResource[] {
  const presentationResources = getPresentationResources(agent);
  const showcaseResources = getShowcaseResources(agent, canAccessShowcase);

  if (
    agent
    // it is a Dove.it agent (it doesn't belong to an agency)
    && agent.agencies?.length === 0
    // it has a proper configuration including PREMIUM_VISIBILITY in extra packages
    && agent.configuration?.extraPackages?.allowedExtraPackages?.map((it) => it.name).includes(ExtraPackageDoveIt.PREMIUM_VISIBILITY)) {
    return [...PREMIUM_MARKETING_RESOURCES, ...presentationResources];
  }
  return [...STANDARD_MARKETING_RESOURCES, ...presentationResources, ...showcaseResources];
}
